import { toast } from 'react-toastify';

// Fire-and-forget app toast in the one house style. Environment
// precondition: something must render react-toastify's <ToastContainer> at
// app root — without it calls are silently dropped.
export function showNotification(
  type: 'error' | 'info' = 'info',
  text: string,
): void {
  toast[type](text, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    icon: false,
  });
}
